export default __webpack_public_path__ + "static/media/pairing-phone.b4f07729.png";